import ServiziPageComponent from "./components/ServiziPageComponent";
import { useSelector } from "react-redux";
import axios from "axios";

const getBestsellers = async () => {
    const { data } = await axios.get("/api/products/bestsellers");
    console.log("[getBestsellers] data =",data);
    return data;
}

const getTypes = async (abctrl) => {
    const {data} = await axios.get("/api/types", {
        signal: abctrl.signal,
    });
    return data
}

const ServiziPage = () => {

    const { categories } = useSelector((state) => state.getCategories);

  return <ServiziPageComponent categories={categories} getBestsellers={getBestsellers} getTypes={getTypes}/>;
};

export default ServiziPage;
